import { canViewGrowthCalculator } from '@utils/investment-entity';
import { FundriseRouteConfig } from 'vue-router';
import { investmentEntity } from '@store/modules/investment-entity';

const growthCalculatorRoutes: Array<FundriseRouteConfig> = [
	{
		path: '/growth-calculator',
		name: 'growth-calculator',
		meta: { minTokenScopeRequired: 'FULL_ACCESS' },
		beforeEnter: async (to, from, next) => {
			if (canViewGrowthCalculator(investmentEntity)) {
				await next();
			} else {
				await next({ name: 'account-overview', replace: true });
			}
		},
		component: () =>
			import(/* webpackChunkName: "growth-calculator" */ '@views/growth-calculator/growth-calculator.vue')
	}
];

export default growthCalculatorRoutes;
